"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
var Language_1 = __importDefault(require("@mui/icons-material/Language"));
var react_intl_1 = require("react-intl");
var DropDownMenu_1 = __importDefault(require("../DropDownMenu"));
var LocaleMenuItem_1 = __importDefault(require("./LocaleMenuItem"));
var Provider_1 = require("./Provider");
var LocaleSelector = function () {
    var authenticated = (0, react_redux_1.useSelector)(function (_a) {
        var user = _a.user;
        return ({
            authenticated: user.authenticated,
        });
    }).authenticated;
    var supportedLocales = (0, react_1.useContext)(Provider_1.SupportedLocalesContext);
    var intl = (0, react_intl_1.useIntl)();
    if (authenticated || supportedLocales.length === 1) {
        return null;
    }
    return (react_1.default.createElement(DropDownMenu_1.default, { buttonContent: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Language_1.default, null),
            react_1.default.createElement(ArrowDropDown_1.default, null))), color: "inherit" }, supportedLocales.map(function (locale) { return (react_1.default.createElement(LocaleMenuItem_1.default, { key: locale, locale: locale, selected: locale === intl.locale })); })));
};
exports.default = LocaleSelector;
